var nurseslounge_myDashboard_followAndFriend = {
    init:function($params){
         nurseslounge_myDashboard_followAndFriend.add_follow($params.guestId);
    },
    add_follow:function($guestId){
        $("#nurseslounge-lounge .follow-button").unbind().click(function(){
            var $data = {
                user_id: libs.memoryGet('user_id'),
                to_user_id: $guestId
            };
            nurseslounge_myDashboard_followAndFriend.follow_request($data, function(){
                libs.refreshBoxFrom('#nurseslounge-lounge .top-nav-menu' , {guestId:$guestId}, function(){
                    nurseslounge_profile.profile({guestId:$guestId});
                });
            });
        });
    },
    /*
    friend_request:function($data, cback){
        $.ajax({
            method: 'POST',
            url:'/myDashboard/header/friends/set',
            data:$data,
            dataType: "json",
            success: function($data){
                libs.expire($data);
                if($data.status == 'success'){
                    cback();
                }
            }
        });
    },
    */
    follow_request:function($data, cback){
        $.ajax({
            method: 'POST',
            url:'/myDashboard/header/follow/set',
            data:$data,
            dataType: "json",
            success: function($data){
                libs.expire($data);
                cback();
            }
        });
    }
};
